export default __webpack_public_path__ + "static/media/Tiktok.8a996831.png";